import { translate } from '@/utils/filters'

const TranslatePlugin = {
    install(Vue) {
        Vue.prototype.$translate = translate
    }
}

export default TranslatePlugin
